import React, { useState, useEffect, useRef } from 'react'
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth } from '../firebase.js';

import { FcGoogle } from 'react-icons/fc'
import g from './ui/GradientBackground.module.css'
import d3 from './Signin.module.css'

import tanqLogo from './media/questa logo white.png'
import { Link } from 'react-router-dom';
import DotsLoader from './ui/Visual-utilities/DotsLoader.js';








function Signin(props) {
   const [loading, setLoading] = useState(false)


   //sign in
   function signingoogle() {//pop up window for signin
      setLoading(true);
      props.isSigningUp(true);
      const provider = new GoogleAuthProvider().setCustomParameters({
         prompt: 'select_account'
      });
      signInWithPopup(auth, provider)
         .then((result) => {
            /** @type {any} */
            const data = result.data;
            console.log('function execution', data)
            setLoading(false);
            //props.refreshUser();
            //props.isSigningUp(false);
         })
         .catch((error) => {
            // props.isSigningUp(false);
            setLoading(false);

            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;

            console.log(errorCode + "    " + errorMessage)
         });
   }



   return (<>


      <div className={d3.container}>

         <div className={d3.context}>
            <img alt='tan-q' className={d3.logo} src={tanqLogo} />



            <div className={d3.rebranding} >
               <div>Kindly Sign In! <br />
                  <p>You need to be signed in to access <u>this</u> page</p>
                  <p className={d3.stayTuned}>beta</p>
               </div>


            </div>


            <div className={d3.text}> Click to <b> auto Sign in</b>  with google</div>
            {!loading ?
               <button onClick={signingoogle} className={d3.button}>
                  <div className={d3.buttonContent}>
                     Sign In <FcGoogle />
                  </div>
               </button> :
               <DotsLoader color='#ffffff' />}
            <div className={d3.footer}> <Link to="/about-us">About Us</Link>.<Link to='/terms-conditions'>Terms & Conditions</Link></div>


         </div>
      </div>
      <div className={g.body}>
         <ul className={g.circles}>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
         </ul>
      </div >
   </>);
}

export default Signin
